import { Pipe, PipeTransform } from '@angular/core';
import { LMFormatUtilService } from '@services/utils';
import { LMModel } from '@form/model';

@Pipe({
  name: 'formatMessageRule'
})
export class LMFormatMessagePipe implements PipeTransform {

  constructor(private lmFormatUtilService: LMFormatUtilService) {}

  transform(value, returnOriginal: boolean, messageRule: LMMessageRule | string, data: LMModel | LMDataView, specFields?: LMSpecFields): string {
    if (messageRule) {
      return this.lmFormatUtilService.formatMessageRule(messageRule, data, specFields);
    }

    if (returnOriginal) {
      return value;
    }

    return '';
  }
}
